export const manageDocumentDownloadsConstants = {
  DOWNLOAD_DOCUMENT_REQUEST: "DOWNLOAD_DOCUMENT_REQUEST",
  DOWNLOAD_DOCUMENT_SUCCESS: "DOWNLOAD_DOCUMENT_SUCCESS",
  DOWNLOAD_DOCUMENT_FAILURE: "DOWNLOAD_DOCUMENT_FAILURE",

  RESET: "RESET_DOCUMENT_DOWNLOAD",
  RESET_ERROR: "RESET_DOWNLOAD_ERROR"
};
